export * from './ArrowTriangularLeft';
